import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { NgxEchartsModule } from 'ngx-echarts';
import { KeycloakInitService } from './shared/auth-services/keycloak-init.service';
import { KeycloakService } from 'keycloak-angular';
import { authHeadersInterceptor } from './interceptors/auth-headers.interceptor';
import { businessErrorResponseInterceptor } from './interceptors/business-error-response.interceptor';
import { PlatformService } from '@shared-lib/services/platform.service.service';
import { ENVIRONMENT_CONFIG } from '@shared-lib/services/environment-config.token';
import { environment } from '../environments/environment';
import { ROUTE_ACCESS_AUTHORIZER } from '@shared-lib/services/route-access.token';

import { CustomGlobalFilterService } from '@shared-lib/services/custom-global-filter.service';
import { CustomChartFilterHandlerService } from '@shared-lib/services/custom-chart-filter-handler.service';
import { GlobalFilterService as SharedGlobalFilterService } from '@shared-lib/services/global-filter-service';
import { ChartFilterHandlerService as SharedChartFilterHandlerService } from '@shared-lib/services/chart-filter-handler.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    importProvidersFrom(
      NgxEchartsModule.forRoot({ echarts: () => import('echarts') }),
    ),
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptors([authHeadersInterceptor, businessErrorResponseInterceptor])),

    // Keycloak initializer
    {
      provide: APP_INITIALIZER,
      useFactory: (KeycloakInitService: KeycloakInitService) => () =>
        KeycloakInitService.initKeycloak(),
      multi: true,
      deps: [KeycloakInitService],
    },

    // Platform API initializer
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: (platformService: PlatformService) => () => platformService.getDashboardConfigFromApi('oh', 'customer-overview').toPromise(),
    //   multi: true,
    //   deps: [PlatformService],
    // },

    KeycloakService,
    { provide: ROUTE_ACCESS_AUTHORIZER, useExisting: KeycloakInitService },
    // PlatformService,

    { provide: SharedGlobalFilterService, useClass: CustomGlobalFilterService },
    {
      provide: SharedChartFilterHandlerService,
      useClass: CustomChartFilterHandlerService,
    },

    // Environment config for shared library components
    {
      provide: ENVIRONMENT_CONFIG,
      useValue: {
        URL: environment.URL,
        COMPANY_LOGO_SRC: environment.COMPANY_LOGO_SRC,
        COMPANY_LOGO_TEXT: environment.COMPANY_LOGO_TEXT,
        HELP_URL: environment.HELP_URL,
        FEEDBACK_URL: environment.FEEDBACK_URL,
      },
    },
  ],
};
